(function () {

  var TRIGGER_HANDLES = [
    'theme-build-ant',
    'theme-build-fire',
    'theme-build-machines',
    'theme-build-patrol-car',
    'sparkblocks-expansion-kit',
    'ultimate-theme-bundle'
  ];

  var SUPPRESSOR_HANDLES = [
    'sparkblocks-intro-kit',
    'advanced-set',
    'family-bundle',
    'sparkblocks-smart-classroom-kit'
  ];

  var INTRO_KIT_HANDLE = 'sparkblocks-intro-kit';
  var POPUP_DELAY_MS = 1500;
  var STORAGE_KEY = 'sb_introKitPopupDismissed';

  var css = [
    '#sb-ik-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:99998;align-items:center;justify-content:center;padding:24px}',
    '#sb-ik-overlay.sb-ik-visible{display:flex}',
    '#sb-ik-modal{background:#fff;border-radius:20px;max-width:680px;width:100%;padding:56px 52px 48px;box-shadow:0 32px 80px rgba(0,0,0,.28);position:relative;text-align:center;font-family:inherit;font-size:18px}',
    '#sb-ik-close{position:absolute;top:18px;right:22px;background:none;border:none;font-size:32px;line-height:1;cursor:pointer;color:#aaa;padding:4px}',
    '#sb-ik-close:hover{color:#333}',
    '#sb-ik-icon{font-size:64px;margin-bottom:20px}',
    '#sb-ik-modal h2{font-size:28px;font-weight:800;margin:0 0 16px;color:#111;line-height:1.2}',
    '#sb-ik-modal p{font-size:18px;color:#555;line-height:1.7;margin:0 0 36px}',
    '#sb-ik-modal p strong{color:#111}',
    '.sb-ik-btn{display:block;width:100%;padding:20px 24px;border-radius:12px;font-size:18px;font-weight:700;cursor:pointer;border:2px solid transparent;margin-bottom:14px;text-align:center}',
    '.sb-ik-btn:last-of-type{margin-bottom:0}',
    '#sb-ik-btn-add{background:#1a1a1a;color:#fff;border-color:#1a1a1a}',
    '#sb-ik-btn-add:hover{opacity:.82}',
    '#sb-ik-btn-add:disabled{opacity:.55;cursor:wait}',
    '#sb-ik-btn-dismiss{background:transparent;color:#666;border-color:#ddd}',
    '#sb-ik-btn-dismiss:hover{border-color:#aaa;color:#222}',
    '#sb-ik-status{font-size:16px;min-height:22px;margin-top:14px;color:#c0392b}',
    '#sb-ik-status.sb-ik-success{color:#27ae60}',
    '@media(max-width:600px){#sb-ik-modal{padding:44px 28px 36px}#sb-ik-modal h2{font-size:24px}#sb-ik-modal p{font-size:17px}.sb-ik-btn{font-size:17px;padding:18px}}'
  ].join('');

  var html = '<div id="sb-ik-overlay" role="dialog" aria-modal="true">'
    + '<div id="sb-ik-modal">'
    + '<button id="sb-ik-close" aria-label="Close">&times;</button>'
    + '<div id="sb-ik-icon">&#9889;</div>'
    + '<h2>Don’t forget the Intro Kit!</h2>'
    + '<p>Every SparkBlocks build starts with the <strong>Intro to Circuits Kit</strong>. It includes the USB-C battery and core circuit blocks required to power our Theme Builds and add-on kits.</p>'
    + '<button class="sb-ik-btn" id="sb-ik-btn-add">Add Intro Kit to cart</button>'
    + '<button class="sb-ik-btn" id="sb-ik-btn-dismiss">I already have an Intro Kit</button>'
    + '<div id="sb-ik-status"></div>'
    + '</div></div>';

  var stylesInjected = false;
  var htmlInjected = false;
  var popupVisible = false;
  var originalFetch = window.fetch.bind(window);

  function injectStyles() { if (stylesInjected) return; var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s); stylesInjected = true; }
  function injectHTML() { if (htmlInjected) return; document.body.insertAdjacentHTML('beforeend', html); htmlInjected = true; }
  function getEl(id) { return document.getElementById(id); }
  function dismiss() { localStorage.setItem(STORAGE_KEY, '1'); popupVisible = false; var o = getEl('sb-ik-overlay'); if (o) o.classList.remove('sb-ik-visible'); }

  function cartHasAny(items, handles) {
    for (var i = 0; i < items.length; i++) {
      for (var j = 0; j < handles.length; j++) {
        if (items[i].handle === handles[j]) return true;
      }
    }
    return false;
  }

  function currentPageIsSuppressed() {
    var path = window.location.pathname.toLowerCase();
    for (var i = 0; i < SUPPRESSOR_HANDLES.length; i++) {
      if (path.indexOf('/products/' + SUPPRESSOR_HANDLES[i]) !== -1) return true;
    }
    return false;
  }

  function addToCart(variantId) {
    var btn = getEl('sb-ik-btn-add'); var status = getEl('sb-ik-status');
    btn.disabled = true; btn.textContent = 'Adding...'; status.textContent = ''; status.className = '';
    originalFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) }).then(function(res) {
      if (!res.ok) { return res.json().then(function(e) { throw new Error(e.description || 'Could not add item.'); }); }
      status.textContent = 'Intro Kit added to your cart!'; status.classList.add('sb-ik-success');
      document.dispatchEvent(new CustomEvent('cart:refresh')); document.dispatchEvent(new CustomEvent('cart-update'));
      setTimeout(dismiss, 1500);
    }).catch(function(e) { status.textContent = e.message || 'Something went wrong.'; btn.disabled = false; btn.textContent = 'Add Intro Kit to my cart'; });
  }

  function showPopup(variantId) {
    if (popupVisible) return; popupVisible = true;
    injectStyles(); injectHTML();
    getEl('sb-ik-overlay').classList.add('sb-ik-visible');
    getEl('sb-ik-close').onclick = dismiss;
    getEl('sb-ik-btn-dismiss').onclick = dismiss;
    getEl('sb-ik-btn-add').onclick = function() { addToCart(variantId); };
    getEl('sb-ik-overlay').onclick = function(e) { if (e.target === getEl('sb-ik-overlay')) dismiss(); };
    document.addEventListener('keydown', function handler(e) { if (e.key === 'Escape') { dismiss(); document.removeEventListener('keydown', handler); } });
  }

  function checkCart() {
    if (localStorage.getItem(STORAGE_KEY)) return;
    if (popupVisible) return;
    if (currentPageIsSuppressed()) return;
    originalFetch('/cart.js').then(function(res) { return res.json(); }).then(function(cart) {
      var items = cart.items || [];
      if (!cartHasAny(items, TRIGGER_HANDLES)) return;
      if (cartHasAny(items, SUPPRESSOR_HANDLES)) return;
      originalFetch('/products/' + INTRO_KIT_HANDLE + '.js').then(function(res) { return res.json(); }).then(function(product) {
        setTimeout(function() { showPopup(product.variants[0].id); }, POPUP_DELAY_MS);
      }).catch(function() {});
    }).catch(function() {});
  }

  window.fetch = function(resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url ? resource.url : '');
    return originalFetch(resource, init).then(function(result) {
      if (url.indexOf('/cart/add') !== -1) { result.clone().json().then(function() { setTimeout(checkCart, 300); }).catch(function() {}); }
      return result;
    });
  };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', checkCart); } else { checkCart(); }

})();
